import React from "react";
import { DPButton } from "Components/DP";
import { useMutation } from "@apollo/client";
import { useReportTerminationContext } from "../ReportTerminationContext";
import mutations from "Shared/mutations";
import { UpdateUserFinalPayMutation, UpdateUserFinalPayMutationVariables } from "generated/graphql";

type Props = {
  onSubmit: () => void;
};

const UpdateUserFinalPaySubmitButton = ({ onSubmit }: Props) => {
  const { employeeProfileId, state } = useReportTerminationContext();
  const [updateUserFinalPayFn] = useMutation<UpdateUserFinalPayMutation, UpdateUserFinalPayMutationVariables>(
    mutations.UPDATE_USER_FINAL_PAY,
    {
      variables: {
        input: {
          netPayCents: state.netPay,
          grossPayCents: state.grossPayCents,
          deductionAmountCents: state.deductionAmountCents,
          finalPayType: state.finalPayType,
          employeeProfileId,
        },
      },
    }
  );

  const handleOnSubmit = async () => {
    const response = await updateUserFinalPayFn();

    if (
      response &&
      response.data &&
      response.data.updateUserFinalPay &&
      response.data.updateUserFinalPay.message
    ) {
      onSubmit();
    }
  };

  return (
    <DPButton
      id="submit"
      align="right"
      color="primary"
      onClick={handleOnSubmit}
    >
      Submit
    </DPButton>
  );
};

export default UpdateUserFinalPaySubmitButton;
